// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1DQVI","alert":"SettungsInbox_alert__3WKHx"};